import { Component, OnDestroy, OnInit } from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	Validators,
} from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { BEACHWATCH_FACEBOOK_URL_EXTERNAL, BEACHWATCH_TWITTER_URL_EXTERNAL, 
	EPA_ENVIRONMENT_LINE_URL_EXTERNAL, REPORT_ALGAL_BLOOMS_URL_EXTERNAL, 
	MEDIA_ENQUIRIES_EMAIL_ADDRESS, MEDIA_ENQURIES_URL } from 'src/app/models/external-urls';

@Component({
	selector: 'app-feedback',
	templateUrl: './feedback.component.html',
	styleUrls: ['./feedback.component.scss'],
})
export class FeedbackComponent implements OnInit, OnDestroy {
	contactUsForm: FormGroup;
	contactTypes = ['General Enquiry', 'Feedback', 'Partnership Interest', 'Other'];
	contactusApiUrl = environment.apiBaseUrl + "/contact_us";
	name = '';
	showFormSuccess = false;
	showFormError = false;
	selectedOption : string;

	public BEACHWATCH_TWITTER_URL = BEACHWATCH_TWITTER_URL_EXTERNAL;
	public BEACHWATCH_FACEBOOK_URL = BEACHWATCH_FACEBOOK_URL_EXTERNAL;
	public EPA_ENVIRONMENT_LINE_URL = EPA_ENVIRONMENT_LINE_URL_EXTERNAL;
	public REPORT_ALGAL_BLOOMS_URL = REPORT_ALGAL_BLOOMS_URL_EXTERNAL;
	public MEDIA_ENQUIRIES_EMAIL_ADDRESS = MEDIA_ENQUIRIES_EMAIL_ADDRESS;
	public MEDIA_ENQUIRIES_MAILTO_URL = `mailto:${MEDIA_ENQUIRIES_EMAIL_ADDRESS}`;
	public MEDIA_ENQURIES_URL = MEDIA_ENQURIES_URL;

	private handle : Subscription;

	constructor(private fb: FormBuilder, private http: HttpClient, private activatedRoute : ActivatedRoute) {
		this.contactUsForm = this.fb.group({
			option: ['', Validators.required],
			name: [''],
			email: ['', [Validators.required, Validators.email]],
			mobile: [''],
			message: ['', Validators.required]
		});
	}


	ngOnInit(): void {
		this.handle = this.activatedRoute.queryParams.subscribe({
			next : (params : any) => 
			{		
				// this is set on the partner details page explore data for partner button at the bottom of partner details page		
				this.selectedOption = params.option ?? "";	
				this.contactUsForm?.get('option')?.patchValue(params.option ?? "");		
			},
			error : (ex : Error) => {

			},
			complete : () => {

		}});	
	}

	ngOnDestroy(): void {
		this.handle && this.handle?.unsubscribe();
	}

	onSubmit() {
		Object.keys(this.contactUsForm.controls).forEach(key => {
			this.contactUsForm.get(key)?.markAsTouched();
		});

		if (this.contactUsForm.valid) {
			console.log('Form submitted.');

			let reqBody = {
				"subject": this.contactUsForm.value.option, "description": this.contactUsForm.value.message,
				"email": this.contactUsForm.value.email, "mobile": this.contactUsForm.value.mobile,
				"name": this.contactUsForm.value.name
			}

			let headers = new HttpHeaders().set('Content-Type', 'application/json');

			this.http.post(this.contactusApiUrl, reqBody, { headers: headers }).subscribe({
				next: (data) => {
					this.contactUsForm.reset();
					this.showFormSuccess = true;
					setTimeout(() => {
						this.showFormSuccess = false;
					}, 15000);
				},
				error: (error) => {
					this.showFormSuccess = false;
					this.showFormError = true;
					setTimeout(() => {
						this.showFormError = false;
					}, 15000);
					console.error('There was an error submitting the message!', error);
				}
			});
		}
	}

	onCancel() {
		console.log('Form cancelled.');
		this.contactUsForm.reset();
	}

	emailValidate(controlName: string) {
		let control = this.contactUsForm.get(controlName);
		let errors = control?.errors;
		if (errors && (errors["email"]) && control?.invalid && (control.dirty || control.touched)) {
			return true;
		}
		else {
			return false;
		}
	}

	requiredValidate(controlName: string) {
		let control = this.contactUsForm.get(controlName);
		let errors = control?.errors;
		if (errors && (errors["required"]) && control?.invalid && (control.dirty || control.touched)) {
			return true;
		}
		else {
			return false;
		}
	}
}
